import script from "./SubmissionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionModal.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionModal.vue?vue&type=style&index=0&id=49f4cbd6&scoped=true&lang=scss"

import exportComponent from "/home/nodeapps/vitamins/edna/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49f4cbd6"]])

export default __exports__